import React from 'react';
import styled from '@emotion/styled';
import {
  Select,
  Toggle,
  Typography,
  colors,
} from '@trustpilot/businessapp-patternlibrary';

interface SyncReviewsProps {
  toggled: boolean;
  period: string;
  setToggled: (toggle: boolean) => void;
  setSyncPeriod: (period: string) => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const Title = styled(Typography)`
  margin: 0px 10px 0 10px;
  color: ${colors.gray[10]};
`;

const Note = styled(Typography)`
  margin: 8px 0 24px 0;
  color: ${colors.gray[30]};
`;

const SelectContainer = styled.div`
  width: 98px;
`;

const SyncReviews = ({ toggled, period, setToggled, setSyncPeriod }: SyncReviewsProps) => {
  const onSyncToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToggled(event.target.checked);
  };
  const onSelectedPeriodChange = (option: { value: string }) => {
    setSyncPeriod(option.value);
  };
  return (
    <>
      <Container>
        <Toggle checked={toggled} onChange={onSyncToggleChange} />
        <Title variant="body-m">
          Sync unanswered reviews from the past
        </Title>
        <SelectContainer>
          <Select disabled={!toggled} value={period} onChange={onSelectedPeriodChange} options={periods} />
        </SelectContainer>
      </Container>
      <Note variant="body-s">
        (Reported and answered reviews won’t be synced.)
      </Note>
    </>
  );
}

export default SyncReviews;

const periods = [
 {
    label: '1 day',
    value: '1',
  },
  {
    label: '2 days',
    value: '2',
  },
  {
    label: '3 days',
    value: '3',
  },
  {
    label: '4 days',
    value: '4',
  },
  {
    label: '5 days',
    value: '5',
  },
  {
    label: '6 days',
    value: '6',
  },
  {
    label: '7 days',
    value: '7',
  },
  {
    label: '8 days',
    value: '8',
  },
  {
    label: '9 days',
    value: '9',
  },
  {
    label: '10 days',
    value: '10',
  },
  {
    label: '11 days',
    value: '11',
  },
  {
    label: '12 days',
    value: '12',
  },
  {
    label: '13 days',
    value: '13',
  },
  {
    label: '2 weeks',
    value: '14',
  },
  {
    label: '3 weeks',
    value: '21',
  },
  {
    label: '4 weeks',
    value: '28',
  },
  {
    label: '6 weeks',
    value: '42',
  },
  {
    label: '2 months',
    value: '60',
  },
  {
    label: '3 months',
    value: '90',
  },
];
